import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { routerReducer } from 'react-router-redux';
import voucherActivate from './voucherActivate';
import questions from './questions';
import sites from './sites';
import jobs from './jobs';
import category from './category';
import location from './location';
import user from './user';
import modals from './modals';
import recommendations from './recommendations';
import messages from './messages';
import contacts from './contacts';
import feedback from './feedback';
import vouchers from './vouchers';

import voucherAdd from './voucherAdd';

import shareableVoucher from './shareableVoucher';

export default combineReducers({
  questions,
  sites,
  jobs,
  category,
  location,
  user,
  modals,
  recommendations,
  messages,
  contacts,
  feedback,
  vouchers,
  shareableVoucher,
  form: formReducer,
  routing: routerReducer,
  voucherActivate,
  voucherAdd
});
